export class SiblingRulebookModel {
  previousId: number;
  nextId: number;

  constructor() {
    this.previousId = 0;
    this.nextId = 0;
  }
}
